import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import {
    setIsReadyForDownload,
    setPurchaseType,
    setShowPurchaseTypeDrawer
} from "core/AssetDownload/Context/actions";

// context
import { PhotosContext } from "photos/context";

// data
import { PHOTO_CHECKOUT } from "data/links";

// scripts
import { setDomFocus } from "photos/helpers";

// components
import PhotoDetailDrawer from "photos/PhotoDetailDrawer";

/*
    Only shown when:
        1. Logged In
        2. Not Public Domain
        3. showPurchaseTypeDrawer
*/

const PurchaseTypeDrawer = () => {
    const {
        state: {
            asset,
            purchaseType,
            showPurchaseTypeDrawer,
            assetDownloadConfig
        },
        dispatch
    } = useContext(AssetDownloadContext);

    const { getPurchaseTypeByKey, purchaseTypeKeys } = assetDownloadConfig;

    const { history } = useContext(PhotosContext);

    if (
        purchaseType.key === purchaseTypeKeys.public ||
        !showPurchaseTypeDrawer
    ) {
        return null;
    }

    const onClose = () => {
        dispatch(setShowPurchaseTypeDrawer(false));
    };

    const onSubmit = photoTypeKey => {
        const purchaseType = getPurchaseTypeByKey(photoTypeKey);

        // If Basic
        if (purchaseType.key === purchaseTypeKeys.basic) {
            dispatch(setIsReadyForDownload(true));
            dispatch(setPurchaseType(purchaseType));
            dispatch(setShowPurchaseTypeDrawer(false));
            // This matches the current business logic in IDP
            // When user clicks continue button, Purchase Options Panel dissapears
            // Focus is returned to the focusable element prior to the Download button(s)
            // Prior Element must be focusable
            setDomFocus("#authorName");
            return;
        }
        // navigate to checkout page
        history.push(
            PHOTO_CHECKOUT.replace(":purchaseType", photoTypeKey).replace(
                ":photoId",
                asset.id
            )
        );
    };

    return (
        <PhotoDetailDrawer
            photo={asset}
            initialSelection={purchaseTypeKeys.large}
            onClose={onClose}
            onSubmit={onSubmit}
        />
    );
};

export default PurchaseTypeDrawer;
